import { render, staticRenderFns } from "./Lab_stretches.vue?vue&type=template&id=737e4cea"
import script from "./Lab_stretches.vue?vue&type=script&lang=js"
export * from "./Lab_stretches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports